(function(){
  function init(form){
    if (form.dataset.sbReady === '1') return;
    form.dataset.sbReady = '1';

    var id = form.getAttribute('data-sb-finder');
    var brandEl = document.querySelector('[data-sb-finder-brands="' + id + '"]');
    var typeEl = document.querySelector('[data-sb-finder-types="' + id + '"]');
    var tree = JSON.parse((brandEl && brandEl.textContent) || '[]');
    var typesTree = JSON.parse((typeEl && typeEl.textContent) || '[]');

    function branchWithGrandchildren(nodes){
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.c && n.c.length && n.c.some(function(c){ return c.c && c.c.length; })) return n;
      }
      return null;
    }
    var brandBranch = branchWithGrandchildren(tree);
    var brands = brandBranch ? brandBranch.c : tree;

    var allTypes = [];
    (function walk(nodes){
      nodes.forEach(function(n){
        if (brandBranch && n === brandBranch) return;
        if (n.c && n.c.length) walk(n.c);
        else if (n.u && n.u.indexOf('/collections/') !== -1) allTypes.push(n);
      });
    })(typesTree);
    var seen = {};
    allTypes = allTypes.filter(function(n){ var k = n.t.trim().toLowerCase(); if (seen[k]) return false; seen[k] = 1; return true; });

    function handleOf(url){ var m = (url || '').match(/\/collections\/([^\/?#]+)/); return m ? m[1] : ''; }
    function baseOf(url){ var h = handleOf(url); return h ? '/collections/' + h : ''; }
    function handleize(s){
      return String(s).toLowerCase()
        .replace(/[à-å]/g, 'a').replace(/[è-ë]/g, 'e').replace(/[ì-ï]/g, 'i')
        .replace(/[ò-ö]/g, 'o').replace(/[ù-ü]/g, 'u').replace(/ç/g, 'c').replace(/ñ/g, 'n')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function pretty(tagValue){
      var v = tagValue.replace(/^type:/, '');
      var hit = allTypes.filter(function(n){ return handleOf(n.u) === v; })[0];
      if (hit) return hit.t.trim();
      return v.replace(/-/g, ' ').replace(/(^|\s)\S/g, function(c){ return c.toUpperCase(); });
    }

    /* ---- Merk-model-producttype collecties (bv. /collections/mercedes-sprinter-imperialen) ---- */
    // Producttypes waarvan de combi-collectie een andere naam heeft dan de type-collectie
    var TYPE_ALIASES = {
      'zonnekleppen': ['zonneklep'],
      'velgensets': ['velgenset', 'wielset'],
      'wielen': ['velgenset', 'wielset'],
      'achterbar-aanrijdbeveiliging': ['achterbar'],
      'bumperbescherming': ['bumperpaneel', 'bumper-beschermer'],
      'bumperpaneel': ['bumperpaneel', 'bumper-beschermer'],
      'laadruimte-mat': ['laadruimtemat'],
      'rubber-laadruimte-mat': ['laadruimtemat'],
      'rvs-imperiaal': ['imperialen'],
      'aluminium-dakdragers': ['dakdragers'],
      'stalen-dakdragers': ['dakdragers'],
      'dak-accessoires': ['opslagsystemen'],
      'deurladder': ['deurladders'],
      'grillen': ['grillen', 'front-grill'],
      'grillen-en-styling': ['grillen', 'front-grill'],
      'bumperbeschermer': ['bumper-beschermer', 'bumperpaneel'],
      'vloer-en-matten': ['vloermatten'],
      'velgen-en-wielen': ['wielset', 'velgenset'],
      'achteropstap': ['achter-opstap'],
      'spatbordverbreders': ['wielkastverbreders-en-uitbouw-delen'],
      'schuifdeurrails': ['schuifdeur-rail'],
      'opslag-en-organizers': ['opslagsystemen']
    };
    function typeSuffixes(t){
      var list = [];
      function add(s){ if (s && list.indexOf(s) === -1) list.push(s); }
      var tagVal = (t.tag || '').replace(/^type:/, '');
      var titleVal = handleize(t.t || '');
      [tagVal, titleVal].forEach(function(v){
        add(v);
        (TYPE_ALIASES[v] || []).forEach(add);
      });
      // enkelvoud/meervoud als laatste redmiddel
      [tagVal, titleVal].forEach(function(v){
        if (!v) return;
        if (/en$/.test(v)) add(v.replace(/en$/, ''));
        else if (/s$/.test(v)) add(v.replace(/s$/, ''));
        else add(v + 's');
      });
      return list;
    }
    var comboCache = {};
    function collectionHasProducts(handle){
      if (comboCache.hasOwnProperty(handle)) return Promise.resolve(comboCache[handle]);
      return fetch('/collections/' + handle + '?view=sb-types')
        .then(function(r){ return r.ok ? r.text() : null; })
        .then(function(txt){
          var ok = txt !== null && txt.trim().length > 0; // bestaat en heeft producten
          comboCache[handle] = ok;
          return ok;
        })
        .catch(function(){ return false; });
    }
    function findCombo(vehicleTitle, t){
      var prefix = handleize(vehicleTitle);
      var candidates = typeSuffixes(t).map(function(s){ return prefix + '-' + s; });
      var i = 0;
      function next(){
        if (i >= candidates.length) return Promise.resolve(null);
        var h = candidates[i++];
        return collectionHasProducts(h).then(function(ok){ return ok ? '/collections/' + h : next(); });
      }
      return next();
    }

    var s1 = form.querySelector('[data-sb-level="1"]');
    var s2 = form.querySelector('[data-sb-level="2"]');
    var s3 = form.querySelector('[data-sb-level="3"]');
    var btn = form.querySelector('[type="submit"]');
    var typePh = s3.options[0] ? s3.options[0].textContent : 'Alle producten';
    function fullTypes(){ return allTypes.map(function(n){ return { t: n.t.trim(), tag: 'type:' + handleOf(n.u), u: n.u }; }); }
    var typeOptions = fullTypes();
    var cache = {};
    var vehicleBase = null;

    function fill(sel, items, placeholder){
      var ph = placeholder || (sel.options[0] ? sel.options[0].textContent : '');
      sel.innerHTML = '';
      var o = document.createElement('option'); o.value = ''; o.textContent = ph; sel.appendChild(o);
      items.forEach(function(it, i){ var op = document.createElement('option'); op.value = String(i); op.textContent = it.t; sel.appendChild(op); });
      sel.disabled = items.length === 0;
    }

    fill(s1, brands);
    fill(s3, typeOptions, typePh);

    function applyTypes(list){
      typeOptions = list && list.length ? list : fullTypes();
      fill(s3, typeOptions, typePh);
    }

    function typesFromCollection(base){
      if (cache[base]) return Promise.resolve(cache[base]);
      var reqs = [1, 2, 3, 4].map(function(p){
        return fetch(base + '?view=sb-types&page=' + p)
          .then(function(r){ return r.ok ? r.text() : ''; })
          .catch(function(){ return ''; });
      });
      return Promise.all(reqs).then(function(texts){
        var found = {};
        texts.forEach(function(txt){
          (txt || '').split('|').forEach(function(t){
            t = t.trim();
            if (t.indexOf('type:') === 0) found[t] = 1;
          });
        });
        var list = Object.keys(found).map(function(t){ return { t: pretty(t), tag: t }; });
        list.sort(function(a, b){ return a.t.localeCompare(b.t); });
        cache[base] = list;
        return list;
      });
    }

    var token = 0;
    function loadTypes(base, fallbackBase){
      var mine = ++token;
      vehicleBase = base;
      fill(s3, [], 'Even zoeken…');
      s3.disabled = true;
      typesFromCollection(base).then(function(list){
        if (mine !== token) return;
        if (list.length) { applyTypes(list); return; }
        if (fallbackBase) {
          return typesFromCollection(fallbackBase).then(function(l2){
            if (mine !== token) return;
            vehicleBase = l2.length ? fallbackBase : null;
            applyTypes(l2);
          });
        }
        vehicleBase = null;
        applyTypes(null);
      }).catch(function(){
        if (mine !== token) return;
        vehicleBase = null;
        applyTypes(null);
      });
    }

    s1.addEventListener('change', function(){
      var b = brands[parseInt(s1.value, 10)];
      if (!b) { fill(s2, [], 'Kies eerst een merk'); vehicleBase = null; applyTypes(null); return; }
      var models = b.c || [];
      fill(s2, models, models.length ? 'Alle modellen' : 'Geen aparte modellen');
      loadTypes(baseOf(b.u), null);
    });

    s2.addEventListener('change', function(){
      var b = brands[parseInt(s1.value, 10)];
      var m = b && b.c ? b.c[parseInt(s2.value, 10)] : null;
      if (m) loadTypes(baseOf(m.u), baseOf(b.u));
      else if (b) loadTypes(baseOf(b.u), null);
    });

    var busy = false;
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if (busy) return;
      var b = brands[parseInt(s1.value, 10)];
      var m = b && b.c ? b.c[parseInt(s2.value, 10)] : null;
      var t = typeOptions[parseInt(s3.value, 10)];
      var url;
      if (t && vehicleBase) { url = vehicleBase + '/' + handleize(t.tag); }
      else if (t) { url = t.u || '/collections/all/' + handleize(t.tag); }
      else if (m) { url = m.u; }
      else if (b) { url = b.u; }
      else { return; }

      // Merk (+ model) + soort product: eerst de vaste collectie merk-model-producttype proberen
      var vehicle = m || b;
      if (t && vehicle) {
        busy = true;
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Zoeken…'; }
        findCombo(vehicle.t, t).then(function(combo){
          window.location.href = combo || url;
        }, function(){
          window.location.href = url;
        }).then(function(){
          // terug-knop (bfcache): knop weer bruikbaar maken
          setTimeout(function(){ busy = false; if (btn) { btn.disabled = false; btn.textContent = label; } }, 1500);
        });
        return;
      }
      window.location.href = url;
    });
  }

  function boot(){ document.querySelectorAll('[data-sb-finder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
